import script from "./SignatureBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureBlock.vue?vue&type=script&setup=true&lang=js"

import "./SignatureBlock.vue?vue&type=style&index=0&id=f5617eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5617eb2"]])

export default __exports__